import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '@app/core/services/loader.service';

@Component({
 selector: 'app-loader',
 standalone: true,
 imports: [CommonModule],
 templateUrl: './loader.component.html',
 styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
 constructor(public loader: LoaderService) {}
}